import { Contract } from "@/services/backend/rlt/contracts/types/contract";
import t from "@/lang/lang";
import { Plus } from "lucide-react";
import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import {
  CommonDialogFooter,
  CommonDialogHeader,
} from "@/shared/components/dialog/dialog-common";
import { useRltContractAddTreatmentCycleMutation } from "@/services/backend/rlt/contracts/api/contract-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { NumberInput } from "@/shared/components/form/number-input";
import { inputValidationErrorMessages } from "@/shared/components/errors/input-error-messages";
import { toast } from "sonner";

export function AddTreatmentCycleDialog({ contract }: { contract: Contract }) {
  const [open, setOpen] = useState(false);
  const [cycle, setCycle] = useState(0);
  const [post, { isLoading, error, isSuccess, reset }] =
    useRltContractAddTreatmentCycleMutation();

  useEffect(() => {
    if (isSuccess) {
      setOpen(false);
      reset();
      toast.success(t("Turnus hinzugefügt"));
    }
  }, [isSuccess, reset]);

  const doDelete = () => {
    if (isLoading) return;

    post({ id: contract.id, cycle });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button>
          <Plus className="size-4" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <CommonDialogHeader
          title={t("Turnus hinzufügen")}
          description={t(
            "Geben Sie den Turnus an, der hinzugefügt werden soll. Ein Turnus kann nur einmal hinzugefügt werden.",
          )}
        />
        <NumberInput
          label={t("Turnus")}
          field="cycle"
          number={cycle}
          onNumberChange={setCycle}
          errors={inputValidationErrorMessages(error, "cycle")}
        />
        <RTKQueryErrorAlert error={error} onDismiss={reset} />
        <CommonDialogFooter isLoading={isLoading} onClickAction={doDelete} />
      </DialogContent>
    </Dialog>
  );
}
